import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, Input, FormErrorMessage, Stack, Select, InputGroup, InputRightElement, Icon } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import EmailValidator from "email-validator";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { ToastContainer, toast } from 'react-toastify';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

export function EditUser({ isOpen = false, onClose = null, userData, refreshData, roles = [], clients = [], creator, authKey }) {
    const initialRef = useRef(null);
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [client, setClient] = useState('');
    const [role, setRole] = useState('');
    const [name, setName] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [isLoading, setIsloading] = useState(false);
    const [emailIsError, setEmailIsError] = useState(false);
    const [show, setShow] = useState(false);
    const [clientEnabled, setClientEnabled] = useState(true);
    const handleClick = () => setShow(!show);

    useEffect(() => {
        if (username.length > 0 && !EmailValidator.validate(username)) {
            setEmailIsError(true);
        }
        else {
            setEmailIsError(false);
        }
    }, [username]);

    useEffect(() => {
        setUserName(userData.username);
        setPassword(userData.passwd);
        setClient(userData.agentId);
        setRole(userData.roleId);
        clientVisibility(userData.roleId);
        setName(userData.name ? userData.name : '');
        setPhoneNo(userData.phoneNo ? userData.phoneNo : '');
        setShow(false);
    }, [userData]);

    const editUser = async () => {
        setIsloading(true);

        const params = {
            username: username.trim(),
            password: password.trim(),
            agentId: client,
            role,
            name: name.trim(),
            phoneNo: phoneNo.trim(),
            creator
        };

        try {
            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${authKey}`
                }
            }

            const response = await axios.post(getAPIEndpoint('user-edit'), params, apiHeader);
            if (response) {
                const { status } = response.data;
                if (status === 'success') {
                    refreshData(authKey);
                    setIsloading(false);
                    onClose();
                }
                else {
                    toast.error("Sorry, we are unable to edit user at this time. Please try again later.");
                }
            }
        } catch (error) {
            toast.error("Sorry, we are unable to edit user at this time. Please try again later.");
            await logger({ task: "Edit user", error: error.toString() });
        }

        setIsloading(false);
    }

    const handleRole = (e) => {
        clientVisibility(e.target.value);
        setRole(e.target.value);
    }

    const clientVisibility = (value) => {
        const admRole = roles.filter(r => r.role === 'Admin');
        if (value === admRole[0].id) {
            setClientEnabled(false);
            setClient('');
        }
        else {
            setClientEnabled(true);
            setClient(userData.agentId);
        }
    }

    const closeModal = () => {
        onClose();
    }

    const processForm = async (e) => {
        e.preventDefault();
        await editUser();
    }

    return (
        <>
            <Modal isCentered initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={processForm}>
                        <ModalHeader>Edit User</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={2} >
                            <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                                <FormControl isInvalid={emailIsError} isRequired>
                                    <Input type='email' disabled={true} ref={initialRef} value={username} placeholder="Email address *" _placeholder={{ color: '#666666' }} onChange={e => setUserName(e.target.value)} />
                                    {emailIsError && <FormErrorMessage>Please enter a valid email address.</FormErrorMessage>}
                                </FormControl>

                                <FormControl isRequired mt={5}>
                                    <InputGroup size='md'>
                                        <Input
                                            fontSize='md'
                                            placeholder="Password *"
                                            _placeholder={{ color: '#666666' }}
                                            type={show ? "text" : "password"}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <InputRightElement display='flex' alignItems='center' mt='4px'>
                                            <Icon
                                                color='gray.400'
                                                _hover={{ cursor: "pointer" }}
                                                as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                                onClick={handleClick}
                                            />
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>

                                <FormControl isRequired mt={5}>
                                    <Input type="text" value={name} _placeholder={{ color: '#666666' }} placeholder="Full name *" onChange={e => setName(e.target.value)} />
                                </FormControl>

                                <FormControl mt={5}>
                                    <Input type="text" _placeholder={{ color: '#666666' }} placeholder="Phone number (optional)" value={phoneNo} onChange={e => setPhoneNo(e.target.value)} />
                                </FormControl>

                                <FormControl isRequired mt={5}>
                                    <Select value={role} placeholder="Select Role *" onChange={handleRole}>
                                        {roles.map((r, k) => <option key={k + 1} value={r.id}>{r.role}</option>)}
                                    </Select>
                                </FormControl>

                                <FormControl mt={5}>
                                    <Select value={client} disabled={!clientEnabled} placeholder="Select Client" onChange={e => setClient(e.target.value)}>
                                        {clients.map((c, k) => <option key={k + 1} value={c.agentId}>{c.agentName}</option>)}
                                    </Select>
                                </FormControl>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Stack direction={'row'}>
                                <Button onClick={closeModal}>Cancel</Button>
                                <Button disabled={emailIsError} isLoading={isLoading} type="submit" bgColor='#0C7FE9' color='white' _hover={{
                                    bg: "#3c98ed"
                                }} mr={3}>
                                    Update User
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <ToastContainer />
        </>
    )
}